import {
  AlignItemsProps,
  color,
  ColorProps,
  compose,
  css,
  flexbox,
  grid,
  GridProps as SSGridProps,
  JustifyItemsProps,
  layout,
  LayoutProps,
  space,
  SpaceProps,
} from '@wrisk/styled-system'
import { PropsWithChildren } from 'react'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { transition, TransitionProps } from '../../transition'
import { collapse, CollapseProps } from '../containers/collapse'
import { containerStyle, ContainerStyleProps } from './containerStyle'
import { displayOn, DisplayOnProps } from './displayOn'

export type GridProps = SSGridProps &
  LayoutProps &
  SpaceProps &
  ContainerStyleProps &
  TransitionProps &
  AlignItemsProps &
  CollapseProps &
  ColorProps &
  DisplayOnProps &
  JustifyItemsProps &
  PropsWithChildren

const defaultProps = withDefaultProps<GridProps>({
  variant: 'default',
})

export const Grid = styled.div.attrs<GridProps>(defaultProps)(
  css({
    display: 'grid',
  }),
  containerStyle,
  compose(grid, flexbox, layout, space, color, transition, collapse, displayOn),
)
